export default __webpack_public_path__ + "static/media/drag-and-drop-image.62d72b3d.svg";